import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Breadcrumbs,
    Link,
    Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { NavLink, useHistory } from "react-router-dom";
import "../../../../Assets/css/mjstatic.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import { base_url, base_url_es } from "../../../../Helpers/request";
import { useSelector } from "react-redux";
import { Home } from "@material-ui/icons";
import Heading from "../ui/Heading";
import { useTranslation } from 'react-i18next'

const faqData = {
    en: [
        {
            title:
                "How can I order an engagement ring online and ensure the correct sizing?",
            value:
                "At Manuel Spinosa Jewelry, we make the online purchasing process completely secure. If you do not know the exact size, we provide measuring tools and digital consultation guides. Furthermore, as designers with our own workshop, we offer the first size adjustment completely free of charge at our boutique to ensure a perfect fit. You can contact our team for personalized assistance directly through our main Manuel Spinosa homepage.",
        },
        {
            title:
                "Is it mandatory to visit the Marbella boutique in person to purchase a Manuel Spinosa Diamonds piece?",
            value:
                "No, it is not necessary. While we love welcoming you to our Marbella boutique to provide an exclusive experience, we serve clients worldwide. You can complete your inquiry online or schedule a private virtual appointment where we will discuss your preferences and budget to make a confident decision. We offer fully insured shipping for all fine jewelry pieces so you can receive your order with complete peace of mind.",
        },
        {
            title:
                "Do you only design engagement rings, or do you offer other types of fine jewelry?",
            value:
                "Although engagement rings are one of our major specialties, we design and craft all types of fine jewelry. In our collections, you will find diamond earrings, exclusive bracelets, wedding bands, and handcrafted necklaces perfect for any special occasion, always under our brand's seal of quality. You can explore our direct craftsmanship philosophy on the Manuel Spinosa Craftsmanship Workshop page.",
        },
        {
            title:
                "Is it possible to design a fully customized engagement ring from scratch?",
            value:
                "Yes, absolutely. We specialize in bespoke, custom-made jewelry. Through 3D CAD design, we bring your vision to life by selecting everything from the precious metal to the gemstones, adapting entirely to your preferences to create a unique and unrepeatable piece. Learn more about our customization process for exclusive pieces directly on the Manuel Spinosa Craftsmanship Workshop page.",
        },
        {
            title:
                "What type of diamonds do you work with in your jewelry workshop?",
            value:
                "We work exclusively with high-quality diamonds and guarantee their ethical origin. We offer both natural diamonds and lab-grown diamonds (created in a controlled environment with the exact same physical and chemical properties), all accompanied by their corresponding international gemological certificates (GIA), ensuring maximum transparency regarding clarity, color, cut, and carat weight. Full details are available on our main Manuel Spinosa page.",
        },
        {
            title:
                "Who will assist me if I decide to book an online consultation?",
            value:
                "You will be assisted directly by our team of expert jewelers or Manuel Spinosa himself in a fully personalized manner. During the virtual appointment video call, we will show you the designs in detail, answer your questions about precious stones or mountings, and guide you step-by-step in choosing your ideal piece, offering the same level of excellence as our physical boutique. You can book your session from our main Manuel Spinosa homepage.",
        },
        {
            title:
                "What engagement ring styles are available, and which one is the most suitable?",
            value:
                "We offer a wide variety of styles to match the personality of each couple. The most prominent designs range from the classic and timeless Solitaire ring (a single diamond symbolizing purity), to sophisticated diamond halo rings (which enhance the brilliance of the center stone), and the emotional Three-Stone or Trilogy design. Each piece is crafted to reflect elegance, personality, and fine taste.",
        },
    ],

    es: [
        {
            title:
                "¿Cómo puedo encargar un anillo de compromiso online y asegurarme de que la talla sea la correcta?",
            value:
                "En Manuel Spinosa Jewelry facilitamos el proceso de compra online de forma totalmente segura. Si no conoces la talla exacta, disponemos de herramientas de medición y guías de asesoramiento digital. Además, al ser diseñadores con taller propio, realizamos el primer ajuste de talla de forma completamente gratuita en nuestra boutique para que el anillo encaje a la perfección. Puedes contactar con nuestro equipo para recibir asistencia personalizada a través de nuestra página principal de Manuel Spinosa.",
        },
        {
            title:
                "¿Es obligatorio visitar la boutique de Marbella para comprar una joya Manuel Spinosa Diamonds?",
            value:
                "No es necesario. Aunque nos encanta recibirte en nuestra boutique de Marbella para ofrecerte una experiencia exclusiva, atendemos a clientes de todo el mundo. Puedes realizar tu consulta de forma online o programar una cita privada virtual en la que hablaremos sobre tus preferencias y presupuesto para tomar una decisión segura. Realizamos envíos de alta joyería totalmente asegurados para que recibas tu pieza con total tranquilidad.",
        },
        {
            title:
                "¿Solo diseñáis anillos de compromiso o tenéis otros tipos de alta joyería?",
            value:
                "Aunque los anillos de compromiso son una de nuestras grandes especialidades, diseñamos y confeccionamos todo tipo de alta joyería fina. En nuestras colecciones encontrarás pendientes de diamantes, pulseras exclusivas, alianzas de boda y gargantillas artesanales ideales para cualquier ocasión especial, siempre bajo el sello de calidad de nuestra firma. Puedes explorar nuestra filosofía de trabajo directo en el Taller de Artesanía de Manuel Spinosa.",
        },
        {
            title:
                "¿Es posible diseñar desde cero un anillo de compromiso totalmente personalizado?",
            value:
                "Sí, por supuesto. Somos especialistas en joyería hecha a medida (bespoke jewelry). A través del diseño 3D CAD, plasmamos tu idea seleccionando desde el metal precioso hasta las gemas, adaptándonos por completo a tus gustos para crear una pieza única e irrepetible. Conoce más sobre nuestro proceso de personalización de piezas exclusivas directamente en la sección del Taller de Artesanía de Manuel Spinosa.",
        },
        {
            title:
                "¿Qué tipo de diamantes trabajáis en vuestro taller de joyería?",
            value:
                "Trabajamos exclusivamente con diamantes de la más alta calidad y garantizamos su procedencia ética. Ofrecemos tanto diamantes naturales como diamantes de laboratorio (creados en entorno controlado con las mismas propiedades físicas y químicas), todos ellos acompañados por sus correspondientes certificados gemológicos internacionales (GIA), asegurando la máxima transparencia en cuanto a su pureza, color, talla y quilates. Tienes toda la información detallada en nuestra página de Manuel Spinosa.",
        },
        {
            title:
                "¿Quién me atenderá si decido concertar una cita de asesoramiento online?",
            value:
                "Te atenderá directamente nuestro equipo de expertos joyeros o el propio Manuel Spinosa de forma totalmente personalizada. Durante la videollamada de la cita virtual, te mostraremos los diseños en detalle, resolveremos tus dudas sobre las piedras preciosas o las monturas y te guiaremos paso a paso en la elección de tu joya ideal, ofreciéndote el mismo nivel de excelencia que en nuestra boutique física. Puedes reservar tu sesión desde nuestra página principal de Manuel Spinosa.",
        },
        {
            title:
                "¿Qué estilos de anillos de compromiso ofrecen y cuál es el más adecuado?",
            value:
                "Ofrecemos una amplia variedad de estilos para encajar con la personalidad de cada pareja. Los diseños más destacados van desde el clásico e imperecedero Anillo Solitario (un único diamante que simboliza la pureza), pasando por los sofisticados anillos con halo de diamantes (que potencian el brillo de la piedra central), hasta el emotivo diseño de Tres Piedras o Trilogy. Cada uno está pensado para reflejar elegancia, personalidad y buen gusto.",
        },
    ],
};

const FaqHome = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const language = useSelector((state) => state.persistedReducer.home.language);
    const [expanded, setExpanded] = React.useState(true);

    const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
    const faqdata = faqData[language] || faqData.en;

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails.title}</title>
                <meta name="description" content={metaDetails.description}></meta>
                <meta name="keywords" content={metaDetails.keywords}></meta>
            </Helmet>
            <div className="rcs_ringsetting_section mt-5">
                <Container>

                    <Row>
                        <Col sm={12}>
                            <Heading>
                                <h2>{(t('FaqHome.heading'))}</h2>
                            </Heading>

                            <div className="rcs_privacy_content rcs_mobile_menu mt-1 mb-2 w-100">

                                {/* <h1>frequently asked question</h1> */}
                                <div className="rcs_faq_accordion mt-2 mb-3">
                                    {faqdata?.map((val, index) =>
                                        index == 0 ? (
                                            <Accordion
                                                expanded={expanded}
                                                onClick={() => setExpanded(!expanded)}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography className="m-0">{val.title}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography className="m-0">
                                                        <p
                                                            dangerouslySetInnerHTML={{ __html: val.value }}
                                                        />
                                                    </Typography>
                                                </AccordionDetails>
                                            </Accordion>
                                        ) : (
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls={"panel1a-content" + index}
                                                    id={"panel1a-header" + index}
                                                >
                                                    <Typography className="m-0">{val.title}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography className="m-0">
                                                        <p
                                                            dangerouslySetInnerHTML={{ __html: val.value }}
                                                        />
                                                    </Typography>
                                                </AccordionDetails>
                                            </Accordion>
                                        ),
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default FaqHome;
